import {
  SlSwitch
} from "./chunk.HGGN4WX3.js";

// src/components/switch/switch.ts
var switch_default = SlSwitch;
SlSwitch.define("sl-switch");

export {
  switch_default
};
